import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

// Product items


const BASE_URL = 'https://admin.lumetiq.in/api';
const DEFAULT_IMAGE = '/assets/img/project/item-1.jpg';
const IMAGE_URL = 'https://admin.lumetiq.in/';
const styles = {
  imageContainer: {
    height: '300px',
    width: '100%',
    overflow: 'hidden',
    position: 'relative' // Add this to ensure proper image positioning
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute', // Add this to ensure the image fills the container
    top: 0,
    left: 0
  }
};



const ProductItems = () => {
  const navigate = useNavigate();
  const { category } = useParams(); // Destructure category from useParams

  const handleProjectClick = (id) => {
    navigate(`/Product-details/${id}`);
  };
  const [ProductData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getImageUrl = (item) => {
      if (!item.image_url) return DEFAULT_IMAGE;
      return `${BASE_URL}/uploads/${item.image_url}`;
    };

    const fetchProductData = async () => {
      try {
        // Reset state before fetching new data
        setProductData([]);
        setLoading(true);
        setError(null);

        const response = await fetch(`https://admin.lumetiq.in/api/products/read.php?category=${category}`);
        if (!response.ok) {
          if (response.status === 404) {
            throw new Error('No products found for this category.');
          } else {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
        }
        const data = await response.json();
        console.log('API Response:', data); // Add this line
        
        // Check if data is an array, if not, check for data.records
        const projects = Array.isArray(data) ? data : (data.records || []);
        console.log('Processed Projects:', projects); // Add this line
        
        setProductData(projects);
        setLoading(false);
      } catch (err) {
        console.error('Fetch error:', err); // Add this line
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProductData();
  }, [category]); // Update dependency to use params.category

  if (loading) {
    return (
      <div className="project-page-list pt-140 pb-90">
        <div className="container">
          <div className="text-center">Loading...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="project-page-list pt-140 pb-90">
        <div className="container">
          <div className="text-center text-danger">{error}</div>
        </div>
      </div>
    );
  }

  // Add this check before the return statement
  const items = Array.isArray(ProductData) ? ProductData : [];

  return (
    <>
      <div className="project-page-list pt-140 pb-90">
        <div className="container">
          <div className="row">
            {items.length === 0 ? (
              <div className="text-center">No Product items found</div>
            ) : (
              items.map((item) => (
                <div key={item.id} className="col-lg-4 col-md-6 col-12">
                  <div className="pj-list-item mb-50" onClick={() => handleProjectClick(item.id)} style={{ cursor: 'pointer' }}>
                    <div className="pj-list__img" style={styles.imageContainer}>
                      <img 
                        src={item.image_path ? `${IMAGE_URL}/${item.image_path}` : DEFAULT_IMAGE} 
                        alt={item.title || 'Project Image'} 
                        style={styles.image}
                        onError={(e) => {
                          console.log('Image failed to load:', e.target.src);
                          e.target.src = DEFAULT_IMAGE;
                        }}
                      />
                    </div>
                    <span>
                      <a href="#">{item.category ||  'Project'}</a>
                    </span>
                    <h4 className="pj-list__title">
                      <Link to={`/Product-details/${item.id}`}>{item.name || 'Untitled Project'}</Link>
                    </h4>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductItems;
